export const defaultBooks = [
  {
    favorite: false,
    kind: "books#volume",
    id: "R7KuDwAAQBAJ",
    etag: "U4kPLzNoxNA",
    selfLink: "https://www.googleapis.com/books/v1/volumes/R7KuDwAAQBAJ",
    volumeInfo: {
      title: "O Senhor dos Anéis: A Sociedade do Anel",
      authors: "J.R.R. Tolkien",
      publisher: "HARLEQUIN",
      publishedDate: "25/11/2019",
      description:
        "A Sociedade do Anel O volume inicial de O Senhor dos Anéis, lançado originalmente em julho de 1954, foi o primeiro grande épico de fantasia moderno, conquistando milhões de leitores e se tornando o padrão de referência para todas as outras obras do gênero até hoje. A imaginação prodigiosa de J.R.R. Tolkien e seu conhecimento profundo das antigas mitologias da Europa permitiram que ele criasse um universo tão complexo e convincente quanto o mundo real. A Sociedade do Anel começa no Condado, a região rural do oeste da Terra-média onde vivem os diminutos e pacatos hobbits. Bilbo Bolseiro, um dos raros aventureiros desse povo, cujas peripécias foram contadas em O Hobbit, resolve ir embora do Condado e deixa sua considerável herança nas mãos de seu jovem parente Frodo. O mais importante legado de Bilbo é o anel mágico que costumava usar para se tornar invisível. No entanto, o mago Gandalf, companheiro de aventuras do velho hobbit, revela a Frodo que o objeto é o Um Anel, a raiz do poder demoníaco de Sauron, o Senhor Sombrio, que deseja escravizar todos os povos da Terra-média. A única maneira de eliminar a ameaça de Sauron é destruir o Um Anel nas entranhas da própria montanha de fogo onde foi forjado. A revelação faz com que Frodo e seus companheiros hobbits Sam, Merry e Pippin deixem a segurança do Condado e iniciem uma perigosa jornada rumo ao leste. Ao lado de representantes dos outros Povos Livres que resistem ao Senhor Sombrio, eles formam a Sociedade do Anel. Alguém uma vez disse que o mundo dos leitores de língua inglesa se divide entre os que já leram O Senhor dos Anéis e os que um dia lerão o livro. Com esta nova tradução da obra, o fascínio dessa aventura atemporal ficará ainda mais evidente para os leitores brasileiros, tanto os que já conhecem a saga como os que estão prestes a descobrir seu encanto.",
      industryIdentifiers: [
        {
          type: "ISBN_13",
          identifier: "9788595086333",
        },
        {
          type: "ISBN_10",
          identifier: "8595086338",
        },
      ],
      readingModes: {
        text: true,
        image: false,
      },
      pageCount: 584,
      printType: "BOOK",
      categories: ["Fiction"],
      maturityRating: "NOT_MATURE",
      allowAnonLogging: true,
      contentVersion: "1.11.12.0.preview.2",
      panelizationSummary: {
        containsEpubBubbles: false,
        containsImageBubbles: false,
      },
      imageLinks: {
        smallThumbnail:
          "http://books.google.com/books/content?id=R7KuDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
        thumbnail:
          "http://books.google.com/books/content?id=R7KuDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
      },
      language: "pt-BR",
      previewLink:
        "http://books.google.com.br/books?id=R7KuDwAAQBAJ&printsec=frontcover&dq=Senhor+dos+Aneis&hl=&cd=1&source=gbs_api",
      infoLink:
        "https://play.google.com/store/books/details?id=R7KuDwAAQBAJ&source=gbs_api",
      canonicalVolumeLink:
        "https://play.google.com/store/books/details?id=R7KuDwAAQBAJ",
    },
    saleInfo: {
      country: "BR",
      saleability: "FOR_SALE",
      isEbook: true,
      listPrice: {
        amount: "R$ 49,90",
        currencyCode: "BRL",
      },
      retailPrice: {
        amount: 47.4,
        currencyCode: "BRL",
      },
      buyLink:
        "https://play.google.com/store/books/details?id=R7KuDwAAQBAJ&rdid=book-R7KuDwAAQBAJ&rdot=1&source=gbs_api",
      offers: [
        {
          finskyOfferType: 1,
          listPrice: {
            amountInMicros: 49900000,
            currencyCode: "BRL",
          },
          retailPrice: {
            amountInMicros: 47400000,
            currencyCode: "BRL",
          },
          giftable: true,
        },
      ],
    },
    accessInfo: {
      country: "BR",
      viewability: "PARTIAL",
      embeddable: true,
      publicDomain: false,
      textToSpeechPermission: "ALLOWED",
      epub: {
        isAvailable: true,
        acsTokenLink:
          "http://books.google.com.br/books/download/O_Senhor_dos_An%C3%A9is_A_Sociedade_do_Anel-sample-epub.acsm?id=R7KuDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api",
      },
      pdf: {
        isAvailable: false,
      },
      webReaderLink:
        "http://play.google.com/books/reader?id=R7KuDwAAQBAJ&hl=&source=gbs_api",
      accessViewStatus: "SAMPLE",
      quoteSharingAllowed: false,
    },
    searchInfo: {
      textSnippet:
        "A imaginação prodigiosa de J.R.R. Tolkien e seu conhecimento profundo das antigas mitologias da Europa permitiram que ele criasse um universo tão complexo e convincente quanto o mundo real.",
    },
  },
  {
    favorite: false,
    kind: "books#volume",
    id: "TnXrDAAAQBAJ",
    etag: "23xMQqDSiyk",
    selfLink: "https://www.googleapis.com/books/v1/volumes/TnXrDAAAQBAJ",
    volumeInfo: {
      title: "Warcraft: livro do filme oficial",
      authors: "Christie Golden",
      publisher: "Galera",
      publishedDate: "26/08/2016",
      description:
        "A versão em livro do filme de ação e fantasia Warcraft. Faz tempo que Azeroth está em paz. Após expulsar os trolls, com a ajuda de Medivh, Guardião do reino, os humanos vivem em paz com os elfos e anões. Mas uma raça temerária de invasores, os guerreiros orcs, insuflados pelo feiticeiro Gul'dan e liderados pelo monstruoso Mão Negra, fogem de seu mundo agonizante em busca de caça e oportunidades. Gul'dan criou um portal capaz de transportar sua Horda até Azeroth. Morte e destruição ameaçam destruir a tudo e a todos. Então, de lados opostos, dois heróis surgem, em uma rota de colisão que decidirá o destino de sua família, seu povo e seu lar. Durotan, o líder honrado do clã Lobo do Gelo, quer apenas uma chance para seu filho recém-nascido. Lothar, o Leão de Azeroth, busca redenção. E assim começa uma espetacular saga sobre poder e sacrifício, na qual a guerra tem muitas facetas e todos lutam por algo.",
      industryIdentifiers: [
        {
          type: "ISBN_13",
          identifier: "9788501108005",
        },
        {
          type: "ISBN_10",
          identifier: "8501108006",
        },
      ],
      readingModes: {
        text: true,
        image: true,
      },
      pageCount: 266,
      printType: "BOOK",
      categories: ["Fiction"],
      maturityRating: "NOT_MATURE",
      allowAnonLogging: false,
      contentVersion: "1.5.5.0.preview.3",
      panelizationSummary: {
        containsEpubBubbles: false,
        containsImageBubbles: false,
      },
      imageLinks: {
        smallThumbnail:
          "http://books.google.com/books/content?id=TnXrDAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
        thumbnail:
          "http://books.google.com/books/content?id=TnXrDAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
      },
      language: "pt-BR",
      previewLink:
        "http://books.google.com.br/books?id=TnXrDAAAQBAJ&printsec=frontcover&dq=Warcraft&hl=&cd=2&source=gbs_api",
      infoLink:
        "https://play.google.com/store/books/details?id=TnXrDAAAQBAJ&source=gbs_api",
      canonicalVolumeLink:
        "https://play.google.com/store/books/details?id=TnXrDAAAQBAJ",
    },
    saleInfo: {
      country: "BR",
      saleability: "FOR_SALE",
      isEbook: true,
      listPrice: {
        amount: "R$ 37,90",
        currencyCode: "BRL",
      },
      retailPrice: {
        amount: 37.9,
        currencyCode: "BRL",
      },
      buyLink:
        "https://play.google.com/store/books/details?id=TnXrDAAAQBAJ&rdid=book-TnXrDAAAQBAJ&rdot=1&source=gbs_api",
      offers: [
        {
          finskyOfferType: 1,
          listPrice: {
            amountInMicros: 37900000,
            currencyCode: "BRL",
          },
          retailPrice: {
            amountInMicros: 37900000,
            currencyCode: "BRL",
          },
          giftable: true,
        },
      ],
    },
    accessInfo: {
      country: "BR",
      viewability: "PARTIAL",
      embeddable: true,
      publicDomain: false,
      textToSpeechPermission: "ALLOWED",
      epub: {
        isAvailable: true,
        acsTokenLink:
          "http://books.google.com.br/books/download/Warcraft_livro_do_filme_oficial-sample-epub.acsm?id=TnXrDAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api",
      },
      pdf: {
        isAvailable: true,
        acsTokenLink:
          "http://books.google.com.br/books/download/Warcraft_livro_do_filme_oficial-sample-pdf.acsm?id=TnXrDAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api",
      },
      webReaderLink:
        "http://play.google.com/books/reader?id=TnXrDAAAQBAJ&hl=&source=gbs_api",
      accessViewStatus: "SAMPLE",
      quoteSharingAllowed: false,
    },
    searchInfo: {
      textSnippet: "A versão em livro do filme de ação e fantasia Warcraft.",
    },
  },
  {
    favorite: false,
    kind: "books#volume",
    id: "7S6OAwAAQBAJ",
    etag: "XDTVdeXi0MU",
    selfLink: "https://www.googleapis.com/books/v1/volumes/7S6OAwAAQBAJ",
    volumeInfo: {
      title: "Tarkin: Star Wars",
      authors: "James Luceno",
      publisher: "Del Rey",
      publishedDate: "04/11/2014",
      description:
        "A long time ago in a galaxy far, far away. . . . Bestselling Star Wars veteran James Luceno gives Grand Moff Tarkin the Star Wars: Darth Plagueis treatment, bringing the legendary character from A New Hope to full, fascinating life. He’s the scion of an honorable and revered family. A dedicated soldier and distinguished legislator. Loyal proponent of the Republic and trusted ally of the Jedi Order. Groomed by the ruthless politician and Sith Lord who would be Emperor, Governor Wilhuff Tarkin rises through the Imperial ranks, enforcing his authority ever more mercilessly . . . and zealously pursuing his destiny as the architect of absolute dominion. Rule through the fear of force rather than force itself, he advises his Emperor. Under Tarkin’s guidance, an ultimate weapon of unparalleled destruction moves ever closer to becoming a terrifying reality. When the so-called Death Star is completed, Tarkin is confident that the galaxy’s lingering pockets of Separatist rebellion will be brought to heel—by intimidation . . . or annihilation. Until then, however, insurgency remains a genuine threat. Escalating guerrilla attacks by resistance forces and newfound evidence of a growing Separatist conspiracy are an immediate danger the Empire must meet with swift and brutal action. And to bring down a band of elusive freedom fighters, the Emperor turns to his most formidable agents: Darth Vader, the fearsome new Sith enforcer as remorseless as he is mysterious; and Tarkin—whose tactical cunning and cold-blooded efficiency will pave the way for the Empire’s supremacy . . . and its enemies’ extinction. Praise for Tarkin “Tarkin tells a compelling tale of mystery while revealing much about a character who has fueled debate among fans since 1977, as well as the oppressive regime he represents. [James] Luceno has proven once again that the villains of Star Wars are as much fun as the good guys.”—New York Daily News “Another home run in the new canon . . . This is the highest and best distillation of Tarkin stories, old and new, we’ve ever been given.”—Big Shiny Robot “A spectacular novel, with the intrigue, action, and profound characterization we have come to expect from the pen of Luceno . . . [Tarkin] provides a nuanced, multi-faceted anti-hero who is captivating, ominous, and calculating; in many ways, this is an origin tale of the Empire [and] a fascinating portrait of one of the more popular characters in the Original Trilogy. It may very well be one my favorite Star Wars novels.”—Coffee with Kenobi “A fascinating look at the pathos of one of the galaxy’s most criminally underused characters.”—TheForce.net",
      industryIdentifiers: [
        {
          type: "ISBN_13",
          identifier: "9780553392890",
        },
        {
          type: "ISBN_10",
          identifier: "0553392891",
        },
      ],
      readingModes: {
        text: true,
        image: false,
      },
      pageCount: 288,
      printType: "BOOK",
      categories: ["Fiction"],
      maturityRating: "NOT_MATURE",
      allowAnonLogging: true,
      contentVersion: "2.8.10.0.preview.2",
      panelizationSummary: {
        containsEpubBubbles: false,
        containsImageBubbles: false,
      },
      imageLinks: {
        smallThumbnail:
          "http://books.google.com/books/content?id=7S6OAwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
        thumbnail:
          "http://books.google.com/books/content?id=7S6OAwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
      },
      language: "en",
      previewLink:
        "http://books.google.com.br/books?id=7S6OAwAAQBAJ&pg=PA85&dq=Star+Wars+Tarkin&hl=&cd=6&source=gbs_api",
      infoLink:
        "https://play.google.com/store/books/details?id=7S6OAwAAQBAJ&source=gbs_api",
      canonicalVolumeLink:
        "https://play.google.com/store/books/details?id=7S6OAwAAQBAJ",
    },
    saleInfo: {
      country: "BR",
      saleability: "FOR_SALE",
      isEbook: true,
      listPrice: {
        amount: "R$ 29,03",
        currencyCode: "BRL",
      },
      retailPrice: {
        amount: 29.03,
        currencyCode: "BRL",
      },
      buyLink:
        "https://play.google.com/store/books/details?id=7S6OAwAAQBAJ&rdid=book-7S6OAwAAQBAJ&rdot=1&source=gbs_api",
      offers: [
        {
          finskyOfferType: 1,
          listPrice: {
            amountInMicros: 29030000,
            currencyCode: "BRL",
          },
          retailPrice: {
            amountInMicros: 29030000,
            currencyCode: "BRL",
          },
          giftable: true,
        },
      ],
    },
    accessInfo: {
      country: "BR",
      viewability: "PARTIAL",
      embeddable: true,
      publicDomain: false,
      textToSpeechPermission: "ALLOWED",
      epub: {
        isAvailable: true,
        acsTokenLink:
          "http://books.google.com.br/books/download/Tarkin_Star_Wars-sample-epub.acsm?id=7S6OAwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api",
      },
      pdf: {
        isAvailable: false,
      },
      webReaderLink:
        "http://play.google.com/books/reader?id=7S6OAwAAQBAJ&hl=&source=gbs_api",
      accessViewStatus: "SAMPLE",
      quoteSharingAllowed: false,
    },
    searchInfo: {
      textSnippet:
        "“The Separatist war machines were shut down, Dangor went on. ... “As Governor Tarkin can attest, our navy was still chasing Separatist holdouts as late as a year ago. ... Rancit began, “back when he was merely \u003cb\u003eSTAR WARS\u003c/b\u003e: \u003cb\u003eTARKIN\u003c/b\u003e 85.",
    },
  },
  {
    favorite: false,
    kind: "books#volume",
    id: "m3lvDwAAQBAJ",
    etag: "fPTl/I4fGkQ",
    selfLink: "https://www.googleapis.com/books/v1/volumes/m3lvDwAAQBAJ",
    volumeInfo: {
      title: "Fogo & Sangue – Volume 1",
      authors: "George R. R. Martin",
      publisher: "Suma",
      publishedDate: "20/11/2018",
      description:
        'A arrebatadora história dos Targaryen ganha vida neste novo livro de George R.R. Martin, autor de As Crônicas de Gelo e Fogo, série que inspirou a adaptação de sucesso da HBO, "Game of Thrones". Séculos antes dos eventos de A guerra dos tronos, a Casa Targaryen – única família de senhores dos dragões a sobreviver à Destruição de Valíria – tomou residência em Pedra do Dragão. A história de Fogo & Sangue começa com o lendário Aegon, o Conquistador, criador do Trono de Ferro, e segue narrando as gerações de Targaryen que lutaram para manter o assento, até a guerra civil que quase destruiu sua dinastia. O que realmente aconteceu durante a Dança dos Dragões? Por que era tão perigoso visitar Valíria depois da Destruição? Quais foram os piores crimes de Maegor, o Cruel? Essas são algumas das questões respondidas neste livro essencial, relatadas por um sábio meistre da Cidadela. Ricamente ilustrado com mais de oitenta imagens assinadas pelo artista Doug Wheatley, Fogo & Sangue dará aos leitores uma nova e completa visão da fascinante história de Westeros – um livro imperdível para os fãs do autor.',
      industryIdentifiers: [
        {
          type: "ISBN_13",
          identifier: "9788554512941",
        },
        {
          type: "ISBN_10",
          identifier: "8554512944",
        },
      ],
      readingModes: {
        text: true,
        image: true,
      },
      pageCount: 664,
      printType: "BOOK",
      categories: ["Fiction"],
      maturityRating: "NOT_MATURE",
      allowAnonLogging: true,
      contentVersion: "1.8.7.0.preview.3",
      panelizationSummary: {
        containsEpubBubbles: false,
        containsImageBubbles: false,
      },
      imageLinks: {
        smallThumbnail:
          "http://books.google.com/books/content?id=m3lvDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
        thumbnail:
          "http://books.google.com/books/content?id=m3lvDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
      },
      language: "pt",
      previewLink:
        "http://books.google.com.br/books?id=m3lvDwAAQBAJ&printsec=frontcover&dq=game+of+thrones&hl=&cd=11&source=gbs_api",
      infoLink:
        "https://play.google.com/store/books/details?id=m3lvDwAAQBAJ&source=gbs_api",
      canonicalVolumeLink:
        "https://play.google.com/store/books/details?id=m3lvDwAAQBAJ",
    },
    saleInfo: {
      country: "BR",
      saleability: "FOR_SALE",
      isEbook: true,
      listPrice: {
        amount: "R$ 39,9",
        currencyCode: "BRL",
      },
      retailPrice: {
        amount: 39.9,
        currencyCode: "BRL",
      },
      buyLink:
        "https://play.google.com/store/books/details?id=m3lvDwAAQBAJ&rdid=book-m3lvDwAAQBAJ&rdot=1&source=gbs_api",
      offers: [
        {
          finskyOfferType: 1,
          listPrice: {
            amountInMicros: 39900000,
            currencyCode: "BRL",
          },
          retailPrice: {
            amountInMicros: 39900000,
            currencyCode: "BRL",
          },
          giftable: true,
        },
      ],
    },
    accessInfo: {
      country: "BR",
      viewability: "PARTIAL",
      embeddable: true,
      publicDomain: false,
      textToSpeechPermission: "ALLOWED",
      epub: {
        isAvailable: true,
        acsTokenLink:
          "http://books.google.com.br/books/download/Fogo_Sangue_Volume_1-sample-epub.acsm?id=m3lvDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api",
      },
      pdf: {
        isAvailable: true,
        acsTokenLink:
          "http://books.google.com.br/books/download/Fogo_Sangue_Volume_1-sample-pdf.acsm?id=m3lvDwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api",
      },
      webReaderLink:
        "http://play.google.com/books/reader?id=m3lvDwAAQBAJ&hl=&source=gbs_api",
      accessViewStatus: "SAMPLE",
      quoteSharingAllowed: false,
    },
    searchInfo: {
      textSnippet:
        "A arrebatadora história dos Targaryen ganha vida neste livro de George R.R. Martin, autor de As Crônicas de Gelo e Fogo, que deu origem à adaptação de sucesso da HBO, &quot;A Casa do Dragão&quot;.",
    },
  },
  {
    favorite: false,
    kind: "books#volume",
    id: "QVR4BwAAQBAJ",
    etag: "/QZnghBV+As",
    selfLink: "https://www.googleapis.com/books/v1/volumes/QVR4BwAAQBAJ",
    volumeInfo: {
      title: "The World of the Witcher",
      subtitle: "Video Game Compendium",
      authors: "CD Projekt Red",
      publisher: "Dark Horse Comics",
      publishedDate: "19/05/2015",
      description:
        "Dive deep into the world of monster hunters, as the prominent characters from the universe take you on a guided tour of the fascinating dark fantasy adventure that is The Witcher. This gorgeous, illustrated hardbound volume contains in-depth knowledge about the locales, the deadly beasts that inhabit them, and the lethal weapons used to put them down.",
      industryIdentifiers: [
        {
          type: "ISBN_13",
          identifier: "9781621159339",
        },
        {
          type: "ISBN_10",
          identifier: "1621159337",
        },
      ],
      readingModes: {
        text: true,
        image: true,
      },
      pageCount: 184,
      printType: "BOOK",
      categories: ["Games & Activities"],
      averageRating: 4,
      ratingsCount: 1,
      maturityRating: "NOT_MATURE",
      allowAnonLogging: true,
      contentVersion: "1.2.2.0.preview.3",
      panelizationSummary: {
        containsEpubBubbles: false,
        containsImageBubbles: false,
      },
      imageLinks: {
        smallThumbnail:
          "http://books.google.com/books/content?id=QVR4BwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
        thumbnail:
          "http://books.google.com/books/content?id=QVR4BwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
      },
      language: "en",
      previewLink:
        "http://books.google.com.br/books?id=QVR4BwAAQBAJ&pg=PT73&dq=The+witcher&hl=&cd=16&source=gbs_api",
      infoLink:
        "https://play.google.com/store/books/details?id=QVR4BwAAQBAJ&source=gbs_api",
      canonicalVolumeLink:
        "https://play.google.com/store/books/details?id=QVR4BwAAQBAJ",
      seriesInfo: {
        kind: "books#volume_series_info",
        bookDisplayNumber: "1",
        volumeSeries: [
          {
            seriesId: "5pDXFwAAABAwhM",
            seriesBookType: "SPECIAL_ISSUE",
            orderNumber: 1,
          },
        ],
      },
    },
    saleInfo: {
      country: "BR",
      saleability: "FOR_SALE",
      isEbook: true,
      listPrice: {
        amount: "R$ 175,91",
        currencyCode: "BRL",
      },
      retailPrice: {
        amount: 175.91,
        currencyCode: "BRL",
      },
      buyLink:
        "https://play.google.com/store/books/details?id=QVR4BwAAQBAJ&rdid=book-QVR4BwAAQBAJ&rdot=1&source=gbs_api",
      offers: [
        {
          finskyOfferType: 1,
          listPrice: {
            amountInMicros: 175910000,
            currencyCode: "BRL",
          },
          retailPrice: {
            amountInMicros: 175910000,
            currencyCode: "BRL",
          },
          giftable: true,
        },
      ],
    },
    accessInfo: {
      country: "BR",
      viewability: "PARTIAL",
      embeddable: true,
      publicDomain: false,
      textToSpeechPermission: "ALLOWED",
      epub: {
        isAvailable: true,
        acsTokenLink:
          "http://books.google.com.br/books/download/The_World_of_the_Witcher-sample-epub.acsm?id=QVR4BwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api",
      },
      pdf: {
        isAvailable: true,
        acsTokenLink:
          "http://books.google.com.br/books/download/The_World_of_the_Witcher-sample-pdf.acsm?id=QVR4BwAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api",
      },
      webReaderLink:
        "http://play.google.com/books/reader?id=QVR4BwAAQBAJ&hl=&source=gbs_api",
      accessViewStatus: "SAMPLE",
      quoteSharingAllowed: false,
    },
    searchInfo: {
      textSnippet:
        "Most \u003cb\u003ewitcher\u003c/b\u003e potions are deadly to those whose bodies are not prepared to handle them. Witchers brew these concoctions using alchemical equipment, learning to do so is an important part of their training. “\u003cb\u003eWitcher\u003c/b\u003e Code—A precise&nbsp;...",
    },
  },
  {
    favorite: false,
    kind: "books#volume",
    id: "AfGEDwAAQBAJ",
    etag: "J0MITCbdXXk",
    selfLink: "https://www.googleapis.com/books/v1/volumes/AfGEDwAAQBAJ",
    volumeInfo: {
      title: "Sherlock Holmes: Obra completa",
      authors: "Arthur Conan Doyle",
      publisher: "HarperCollins Brasil",
      publishedDate: "15/05/2015",
      description:
        "Em 1887, o escritor escocês sir Arthur Conan Doyle criou Sherlock Holmes, o infalível detetive a quem os agentes da Scotland Yard recorriam para solucionar os mistérios mais intrigantes da Inglaterra vitoriana. Desde então, as aventuras do mestre da investigação atraem leitores ávidos por chegar à última página e ver o enigma desvendado.Esta obra completa reúne os quatro romances e os 56 contos sobre as aventuras do detetive mais famoso do mundo e de seu fiel companheiro, o dr. Watson.Para desvendar mistérios, o faro e a astúcia de Sherlock Holmes levam às fontes menos óbvias, às informações mais precisas. Um modelo que influencia até hoje a literatura policial e revela fôlego para impressionar gerações de leitores através dos tempos.Esta edição é dividida em quatro volumes: VOLUME 1 Um estudo em vermelho (romance) - 1887 O sinal dos quatro (romance) - 1890 As aventuras de Sherlock Holmes (contos) - 1892 VOLUME 2 Memórias de Sherlock Holmes (contos) - 1894 O cão dos Baskerville (romance) - 1902 VOLUME 3 A volta de Sherlock Holmes (contos) - 1905 O vale do medo (romance) - 1915 VOLUME 4 Os últimos casos de Sherlock Holmes (contos) - 1917 Histórias de Sherlock Holmes (contos) - 1927",
      industryIdentifiers: [
        {
          type: "ISBN_13",
          identifier: "9788520924105",
        },
        {
          type: "ISBN_10",
          identifier: "8520924107",
        },
      ],
      readingModes: {
        text: true,
        image: false,
      },
      pageCount: 1795,
      printType: "BOOK",
      categories: ["Fiction"],
      maturityRating: "NOT_MATURE",
      allowAnonLogging: true,
      contentVersion: "1.11.9.0.preview.2",
      panelizationSummary: {
        containsEpubBubbles: false,
        containsImageBubbles: false,
      },
      imageLinks: {
        smallThumbnail:
          "http://books.google.com/books/content?id=AfGEDwAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
        thumbnail:
          "http://books.google.com/books/content?id=AfGEDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
      },
      language: "pt",
      previewLink:
        "http://books.google.com.br/books?id=AfGEDwAAQBAJ&pg=PP1&dq=Sherlock+Holmes&hl=&cd=15&source=gbs_api",
      infoLink:
        "https://play.google.com/store/books/details?id=AfGEDwAAQBAJ&source=gbs_api",
      canonicalVolumeLink:
        "https://play.google.com/store/books/details?id=AfGEDwAAQBAJ",
    },
    saleInfo: {
      country: "BR",
      saleability: "FOR_SALE",
      isEbook: true,
      listPrice: {
        amount: "R$ 29,21",
        currencyCode: "BRL",
      },
      retailPrice: {
        amount: 27.75,
        currencyCode: "BRL",
      },
      buyLink:
        "https://play.google.com/store/books/details?id=AfGEDwAAQBAJ&rdid=book-AfGEDwAAQBAJ&rdot=1&source=gbs_api",
      offers: [
        {
          finskyOfferType: 1,
          listPrice: {
            amountInMicros: 29210000,
            currencyCode: "BRL",
          },
          retailPrice: {
            amountInMicros: 27750000,
            currencyCode: "BRL",
          },
          giftable: true,
        },
      ],
    },
    accessInfo: {
      country: "BR",
      viewability: "PARTIAL",
      embeddable: true,
      publicDomain: false,
      textToSpeechPermission: "ALLOWED",
      epub: {
        isAvailable: true,
        acsTokenLink:
          "http://books.google.com.br/books/download/Sherlock_Holmes_Obra_completa-sample-epub.acsm?id=AfGEDwAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api",
      },
      pdf: {
        isAvailable: false,
      },
      webReaderLink:
        "http://play.google.com/books/reader?id=AfGEDwAAQBAJ&hl=&source=gbs_api",
      accessViewStatus: "SAMPLE",
      quoteSharingAllowed: false,
    },
    searchInfo: {
      textSnippet:
        "Em 1887, o escritor escocês sir Arthur Conan Doyle criou Sherlock Holmes, o infalível detetive a quem os agentes da Scotland Yard recorriam para solucionar os mistérios mais intrigantes da Inglaterra vitoriana.",
    },
  },
  {
    favorite: false,
    kind: "books#volume",
    id: "_i6bDeoCQzsC",
    etag: "+8D3OjjpnS4",
    selfLink: "https://www.googleapis.com/books/v1/volumes/_i6bDeoCQzsC",
    volumeInfo: {
      title: "Clean Code",
      subtitle: "A Handbook of Agile Software Craftsmanship",
      authors: "Robert C. Martin",
      publisher: "Pearson Education",
      publishedDate: "01/08/2008",
      description:
        "Even bad code can function. But if code isn’t clean, it can bring a development organization to its knees. Every year, countless hours and significant resources are lost because of poorly written code. But it doesn’t have to be that way. Noted software expert Robert C. Martin presents a revolutionary paradigm with Clean Code: A Handbook of Agile Software Craftsmanship . Martin has teamed up with his colleagues from Object Mentor to distill their best agile practice of cleaning code “on the fly” into a book that will instill within you the values of a software craftsman and make you a better programmer–but only if you work at it. What kind of work will you be doing? You’ll be reading code–lots of code. And you will be challenged to think about what’s right about that code, and what’s wrong with it. More importantly, you will be challenged to reassess your professional values and your commitment to your craft. Clean Code is divided into three parts. The first describes the principles, patterns, and practices of writing clean code. The second part consists of several case studies of increasing complexity. Each case study is an exercise in cleaning up code–of transforming a code base that has some problems into one that is sound and efficient. The third part is the payoff: a single chapter containing a list of heuristics and “smells” gathered while creating the case studies. The result is a knowledge base that describes the way we think when we write, read, and clean code. Readers will come away from this book understanding How to tell the difference between good and bad code How to write good code and how to transform bad code into good code How to create good names, good functions, good objects, and good classes How to format code for maximum readability How to implement complete error handling without obscuring code logic How to unit test and practice test-driven development This book is a must for any developer, software engineer, project manager, team lead, or systems analyst with an interest in producing better code.",
      industryIdentifiers: [
        {
          type: "ISBN_13",
          identifier: "9780136083252",
        },
        {
          type: "ISBN_10",
          identifier: "0136083250",
        },
      ],
      readingModes: {
        text: true,
        image: true,
      },
      pageCount: 464,
      printType: "BOOK",
      categories: ["Computers"],
      averageRating: 4.5,
      ratingsCount: 9,
      maturityRating: "NOT_MATURE",
      allowAnonLogging: true,
      contentVersion: "3.17.11.0.preview.3",
      panelizationSummary: {
        containsEpubBubbles: false,
        containsImageBubbles: false,
      },
      imageLinks: {
        smallThumbnail:
          "http://books.google.com/books/content?id=_i6bDeoCQzsC&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
        thumbnail:
          "http://books.google.com/books/content?id=_i6bDeoCQzsC&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
      },
      language: "en",
      previewLink:
        "http://books.google.com.br/books?id=_i6bDeoCQzsC&printsec=frontcover&dq=clean+code&hl=&cd=1&source=gbs_api",
      infoLink:
        "https://play.google.com/store/books/details?id=_i6bDeoCQzsC&source=gbs_api",
      canonicalVolumeLink:
        "https://play.google.com/store/books/details?id=_i6bDeoCQzsC",
    },
    saleInfo: {
      country: "BR",
      saleability: "FOR_SALE",
      isEbook: true,
      listPrice: {
        amount: "R$ 118,54",
        currencyCode: "BRL",
      },
      retailPrice: {
        amount: 95.17,
        currencyCode: "BRL",
      },
      buyLink:
        "https://play.google.com/store/books/details?id=_i6bDeoCQzsC&rdid=book-_i6bDeoCQzsC&rdot=1&source=gbs_api",
      offers: [
        {
          finskyOfferType: 1,
          listPrice: {
            amountInMicros: 118540000,
            currencyCode: "BRL",
          },
          retailPrice: {
            amountInMicros: 95170000,
            currencyCode: "BRL",
          },
          giftable: true,
        },
      ],
    },
    accessInfo: {
      country: "BR",
      viewability: "PARTIAL",
      embeddable: true,
      publicDomain: false,
      textToSpeechPermission: "ALLOWED_FOR_ACCESSIBILITY",
      epub: {
        isAvailable: false,
      },
      pdf: {
        isAvailable: false,
      },
      webReaderLink:
        "http://play.google.com/books/reader?id=_i6bDeoCQzsC&hl=&source=gbs_api",
      accessViewStatus: "SAMPLE",
      quoteSharingAllowed: false,
    },
    searchInfo: {
      textSnippet:
        "Readers will come away from this book understanding How to tell the difference between good and bad code How to write good code and how to transform bad code into good code How to create good names, good functions, good objects, and good ...",
    },
  },
  {
    favorite: false,
    kind: "books#volume",
    id: "8ciHAAAAQBAJ",
    etag: "WSvTQmfppUk",
    selfLink: "https://www.googleapis.com/books/v1/volumes/8ciHAAAAQBAJ",
    volumeInfo: {
      title: "As armas da persuasão",
      subtitle: "Como influenciar e não se deixar influenciar",
      authors: "Robert B. Cialdini",
      publisher: "Sextante",
      publishedDate: "27/08/2013",
      description:
        'Depois de passar anos caindo na lábia de vendedores, arrecadadores de doações e operadores de telemarketing, o psicólogo Robert B. Cialdini resolveu se dedicar ao estudo da persuasão. Ele queria entender quais são os fatores que levam uma pessoa a dizer "sim" a um pedido e que técnicas exploram melhor esses fatores. Reunindo dados das mais recentes pesquisas científicas sobre o assunto, histórias de gente comum e a experiência adquirida ao se infiltrar em organizações que treinam os chamados "profissionais da persuasão", Cialdini criou uma obra acessível, informativa e indispensável a todos aqueles que querem saber como influenciar pessoas e, ao mesmo tempo, se defender dos manipuladores. Seis princípios psicológicos básicos governam o comportamento humano quando tomamos uma decisão e podem ser usados como verdadeiras armas: 1. Reciprocidade: nos sentimos compelidos a retribuir, nem sempre de forma vantajosa para nós, o que outra pessoa nos proporcionou 2. Compromisso e coerência: depois que fazemos uma escolha, enfrentamos pressões para nos comportarmos de maneira condizente com o compromisso assumido 3. Aprovação social: buscamos nos outros indícios do comportamento mais apropriado a seguir 4. Afeição: preferimos acatar pedidos de pessoas que conhecemos e de que gostamos 5. Autoridade: temos um arraigado senso de obediência à autoridade 6. Escassez: tudo se torna mais valioso quando fica menos disponível Cada princípio é discutido pelo autor em termos de sua função na sociedade e de como um profissional da persuasão pode mobilizar seu poder em pedidos de compras, doações, concessões, votos, permissões, etc. Além disso, aprendemos a usar essas técnicas a nosso favor nas interações diárias de todo tipo, com vizinhos, amigos, colegas, parceiros de negócios ou familiares.',
      industryIdentifiers: [
        {
          type: "ISBN_13",
          identifier: "9788575428528",
        },
        {
          type: "ISBN_10",
          identifier: "8575428527",
        },
      ],
      readingModes: {
        text: true,
        image: true,
      },
      pageCount: 433,
      printType: "BOOK",
      categories: ["Business & Economics"],
      maturityRating: "NOT_MATURE",
      allowAnonLogging: true,
      contentVersion: "0.45.43.0.preview.3",
      panelizationSummary: {
        containsEpubBubbles: false,
        containsImageBubbles: false,
      },
      imageLinks: {
        smallThumbnail:
          "http://books.google.com/books/content?id=8ciHAAAAQBAJ&printsec=frontcover&img=1&zoom=5&edge=curl&source=gbs_api",
        thumbnail:
          "http://books.google.com/books/content?id=8ciHAAAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
      },
      language: "pt-BR",
      previewLink:
        "http://books.google.com.br/books?id=8ciHAAAAQBAJ&printsec=frontcover&dq=armas+da+persuas%C3%A3o&hl=&cd=2&source=gbs_api",
      infoLink:
        "https://play.google.com/store/books/details?id=8ciHAAAAQBAJ&source=gbs_api",
      canonicalVolumeLink:
        "https://play.google.com/store/books/details?id=8ciHAAAAQBAJ",
    },
    saleInfo: {
      country: "BR",
      saleability: "FOR_SALE",
      isEbook: true,
      listPrice: {
        amount: "R$ 32,99",
        currencyCode: "BRL",
      },
      retailPrice: {
        amount: 31.34,
        currencyCode: "BRL",
      },
      buyLink:
        "https://play.google.com/store/books/details?id=8ciHAAAAQBAJ&rdid=book-8ciHAAAAQBAJ&rdot=1&source=gbs_api",
      offers: [
        {
          finskyOfferType: 1,
          listPrice: {
            amountInMicros: 32990000,
            currencyCode: "BRL",
          },
          retailPrice: {
            amountInMicros: 31340000,
            currencyCode: "BRL",
          },
          giftable: true,
        },
      ],
    },
    accessInfo: {
      country: "BR",
      viewability: "PARTIAL",
      embeddable: true,
      publicDomain: false,
      textToSpeechPermission: "ALLOWED",
      epub: {
        isAvailable: true,
        acsTokenLink:
          "http://books.google.com.br/books/download/As_armas_da_persuas%C3%A3o-sample-epub.acsm?id=8ciHAAAAQBAJ&format=epub&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api",
      },
      pdf: {
        isAvailable: true,
        acsTokenLink:
          "http://books.google.com.br/books/download/As_armas_da_persuas%C3%A3o-sample-pdf.acsm?id=8ciHAAAAQBAJ&format=pdf&output=acs4_fulfillment_token&dl_type=sample&source=gbs_api",
      },
      webReaderLink:
        "http://play.google.com/books/reader?id=8ciHAAAAQBAJ&hl=&source=gbs_api",
      accessViewStatus: "SAMPLE",
      quoteSharingAllowed: false,
    },
    searchInfo: {
      textSnippet:
        "Depois de passar anos caindo na lábia de vendedores, arrecadadores de doações e operadores de telemarketing, o psicólogo Robert B. Cialdini resolveu se dedicar ao estudo da persuasão.",
    },
  },
];
